/*=========================================================================================
  File Name: moduleEmailGetters.js
  Description: Email Module Getters
  ----------------------------------------------------------------------------------------

==========================================================================================*/


export default {
  filteredMails: state => state.mails.filter((mail) => {
    if(state.mail_filter === "all_mail") return true;
    else return (state.mail_filter === 'starred' ? mail.isStarred : state.mail_filter === mail.mailFolder || mail.labels.includes(state.mail_filter)) && (mail.sender_name.toLowerCase().includes(state.mailSearchQuery.toLowerCase()) || mail.sender.toLowerCase().includes(state.mailSearchQuery.toLowerCase()) || mail.subject.toLowerCase().includes(state.mailSearchQuery.toLowerCase()) || mail.message.toLowerCase().includes(state.mailSearchQuery.toLowerCase()))
  }),
  checkMailGotten: state => (object) => state.mailSelected.find((email) => {
    // email.id === emailId
    return email.id = object.sequence
        // && email
  } ),
  getMail: state => (id) => state.mailSelected.find((mail) => {
    return id == mail.id
  } ),
  
  listMailInFolder: state => state.mails,
  getFolders: state => state.mailFolders,

  getCurrentEmailSelected: state => state.accountEmailSelect,

  getCurrentFolderSelected: state => state.folderSelect,


  getNewMail: state => state.mails.filter(mail => {
    return mail.unread
  }),
  getMailSent: state => state.mails.filter(mail =>{
    return mail.mailFolder == 'sent'
  }),
  getMailDrafts: state => state.mails.filter(mail =>{
    return mail.mailFolder == 'drafts'
  }),
  getMailNotDrafts: state => state.mails.filter(mail =>{
    return mail.mailFolder != 'drafts'
  }),
}
